import logo from '../../assets/images/logo.svg';

export default function AccountPolicy() {
    return (
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-lg-10">
                    <div className="p-4 p-md-5 rounded shadow-lg fs-5 border border-2">
                        <img
                            className="img-fluid d-block mx-auto"
                            src={logo}
                            alt="avatar"
                            width="100"
                        />
                        <h4 className="text-center">
                            Bangladesh College of Physicians and Surgeons (BCPS)
                        </h4>
                        <hr />
                        <h5 className="text-center mb-4">eLogbook Account & Data Deletion Policy</h5>

                        <p>
                            The <strong>eLogbook system</strong> is operated by the{' '}
                            <strong>Bangladesh College of Physicians and Surgeons (BCPS)</strong>, which manages
                            official postgraduate medical training records for doctors in Bangladesh, including{' '}
                            <strong>FCPS/MCPS programs</strong>.
                        </p>

                        <p>
                            In compliance with <strong>national medical regulations</strong> and BCPS policy:
                        </p>

                        <ul className="mb-4">
                            <li className="mb-3">
                                <strong>User accounts and associated training data cannot be deleted.</strong>
                            </li>
                            <li>
                                Preservation of this information is mandatory for lifelong verification of a doctor's
                                education, training, thesis/dissertation, procedures, and certification history.
                            </li>
                        </ul>

                        <h2 className="h4 my-3">Key Points</h2>

                        <ol className="mb-4">
                            <li className="mb-3">
                                Users <strong>cannot request account deletion</strong>.
                            </li>
                            <li className="mb-3">
                                Users <strong>cannot request deletion</strong> of training data, profile information,
                                or submitted documents.
                            </li>
                            <li className="mb-3">
                                All training data is securely stored for{' '}
                                <strong>official accreditation, legal, and regulatory purposes</strong>.
                            </li>
                        </ol>

                        <h2 className="h4 my-3">Questions or Corrections</h2>

                        <p>
                            If you notice <strong>inaccurate information</strong> or have questions regarding your
                            account, you may contact BCPS:
                        </p>

                        <ul className="list-unstyled ms-3 mb-0">
                            <li className="mb-2">
                                <strong>Email:</strong>{' '}
                                <a href="mailto:it@bcps.edu.bd">it@bcps.edu.bd</a>
                                {' , '}
                                <a href="mailto:itconsultant@bcps.edu.bd">itconsultant@bcps.edu.bd</a>
                            </li>
                            <li>
                                <strong>Phone:</strong> 01717-537924, 01761-116708
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}